import React from 'react';
import './ExtractStatement.css';

type ExtractStatementProps = {
  extract: any;
  onClick: () => void;
};

const ExtractStatement: React.FC<ExtractStatementProps> = ({
  extract,
  onClick,
}) => {
  const isRefund =
    extract.statementOrderState === 'canceled' ||
    extract.statementOrderState === 'refunded';
  return (
    <div
      onClick={onClick}
      key={extract.statementId}
      className='extract-statement-container'
    >
      <div className='extract-statement-type-container'>
        <b>{extract.statementTitle}</b>
        {extract.statementSubtitle && <p>{extract.statementSubtitle}</p>}
        <p>{extract.statementDate}</p>
      </div>
      <span
        className='extract-statement-ammount'
        style={isRefund ? { textDecoration: 'line-through' } : {}}
      >{`${
        !isRefund &&
        (extract.statementTitle === 'Adicionou' ||
          extract.statementTransfer === 'in')
          ? '+ '
          : ''
      } ${extract.statementValue}`}</span>
    </div>
  );
};

export default ExtractStatement;
